










import Vue from 'vue'

import types from '../../store/types'
import {Shape, Current} from '../../interface'

export default Vue.extend({

  data(): {
    isLoaded: boolean
  } {
    return {
      isLoaded: true
    }
  },

  computed: {
    image(): string {
      this.isLoaded = false
      const imageData: string = this.$store.state.Current.file.result

      const imageElem: HTMLImageElement = document.createElement('img')
      imageElem.addEventListener('load', () => {
        this.init(imageElem)
        this.isLoaded = true
      })
      imageElem.src = imageData

      return imageData
    },
    styleObject() {
      const current: Current = this.$store.state.Current

      return {
        transform:
          'translate(' + current.x + '%, ' + current.y + '%) ' +
          'scale(' + current.scale + ') ' +
          'rotate(' + current.rotate + 'deg)'
      }
    }
  },

  methods: {
    init(imageElem: HTMLImageElement): void {
      const shapeIndex: number = this.$store.state.Current.shape
      const shapeList: Shape[] = this.$store.state.Shape.list

      if (! shapeList[shapeIndex]) {
        return
      }

      // If not isNew, not initialize Current State
      if (
        ! this.$store.state.Current.isNew &&
        ! this.$store.state.Current.isChangeImage
      ) {
        return
      }

      const shapeInfo: Shape = shapeList[shapeIndex]

      const orgScale = shapeInfo.width / imageElem.width

      let imgScale = 1
      let imgWidth = 0

      if (imageElem.width > imageElem.height) {
          imgScale = shapeInfo.height / imageElem.height
      } else {
          imgScale = orgScale
      }
      imgWidth = imageElem.width * imgScale

      const scale = imgWidth / shapeInfo.width
      const x = 0
      const y = (imageElem.width - imageElem.height) / 2 / imageElem.height * 100

      this.$store.commit(types.mutations.CURRENT_ROTATE, 0)
      this.$store.commit(types.mutations.CURRENT_SCALE, scale)
      this.$store.commit(types.mutations.CURRENT_X, x)
      this.$store.commit(types.mutations.CURRENT_Y, y)
      this.$store.commit(types.mutations.CURRENT_IMAGE_WIDTH, imageElem.width)
      this.$store.commit(types.mutations.CURRENT_IMAGE_HEIGHT, imageElem.height)
    }
  }

})
